export function jsonToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';
  var line = '';

  for (var index in array[0]) {
    var value = index + "";
    line += '"' + value.replace(/"/g, '""') + '",';
  }
  line = line.slice(0, -1);
  str += line + '\r\n';

  for (var i = 0; i < array.length; i++) {
    line = '';
    for (var index2 in array[i]) {
      var value2 = array[i][index2] + "";
      line += '"' + value2.replace(/"/g, '""') + '",';
    }
    line = line.slice(0, -1);
    str += line + '\r\n';
  }
  return str;
}
